var map = {
	"./": [
		8913,
		916,
		848,
		754,
		913
	],
	"./MoscowRoads": [
		1875,
		848
	],
	"./MoscowRoads.tsx": [
		1875,
		848
	],
	"./RostovRoads": [
		7754,
		754
	],
	"./RostovRoads.tsx": [
		7754,
		754
	],
	"./SpbRoads": [
		9916,
		916
	],
	"./SpbRoads.tsx": [
		9916,
		916
	],
	"./index": [
		8913,
		916,
		848,
		754,
		913
	],
	"./index.ts": [
		8913,
		916,
		848,
		754,
		913
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6500;
module.exports = webpackAsyncContext;